'use strict';

export default {
    community: window.appConfig.community || {},
    terms: undefined
};
